<template>
  <div class="miya-lang" @click.stop="clickChangeLang()">
    <p class="lang" :class="{lang1: isHome, bg: pageWidth < 800}"><span>{{pageWidth < 800 ? $t('home.lang1') : $t('home.lang')}}</span></p>
    <!-- <div class="bg" v-if=""></div> -->
    <i class="icon-lang" :class="{icon1: isHome}"></i>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isHome: false,
    }
  },
  created () {
    if (this.storage && this.storage.save_language) {
      let lang = this.storage.save_language
      console.log("current lang:"+lang)
      this.setLang(lang)
    }else{
      if(navigator.language!="zh-CN"){
        this.setLang('EN')
      }
      // this.$get(`/Check/IsChineseIP`).then(res => {
      //   if (res.code === 200&&!res.result) {
      //     this.setLang('EN')
      //   } else if (res.code === 500) {
      //     this.$message.error(res.message)
      //   }
      // })
    }
    this.getData()
  },
  methods: {
    getData () {
      this.isHome = this.$route.path === '/home'
    },
    clickChangeLang () {  
      let lang = ''
      if (this.language === 'CN') {
        lang = 'EN'
      } else {
        lang = 'CN'
      }
      this.setLang(lang)
    },
    setLang (lang) {
      this.$store.commit('set_language', lang)  
      this.$i18n.locale = lang   
      this.saveStorage({key: 'save_language', val: lang})
    },
  },
}
</script>
<style scoped lang="stylus">
.miya-lang
  display flex
  cursor pointer
  &:hover
    .lang
      color $c1
    .lang1
      color $c7
  .lang
    font-size $f16
    color $c2
    margin-right 10px
  .lang1
    color $c7
  .icon-lang
    width 19px
    height 16px
    margin 27px 0
    background url('../assets/images/home/lang1.svg')
  .icon1
    background url('../assets/images/home/lang2.svg')
@media screen and (max-width: 800px) 
  .miya-lang
    &:hover
      .lang, .lang1
        color $c1 
    .lang
      font-size 0.8rem
      line-height 1.5rem
      margin-top 1rem
    .lang1
      margin-top 0
      line-height 72px
    .icon-lang
      display none
    .bg
      position relative
      span
        position relative
        z-index 2
      &:before
        content ''
        position absolute
        top 50%
        left 50%
        transform translate3d(-50%, -50%, 0)
        width 1.5rem
        height 1.5rem
        border-radius 50%
        background-color #F0F0F0
        z-index 1
    .lang1
      color $c1 
</style>